export const ServicesModuleName: string = "league-manager-services";
import { NgModule } from "angular-ts-decorators";
import { AgeGroupService } from "./AgeGroupService";
import { AuthService } from "./AuthService";
import { AvailabilityService } from "./AvailabilityService";
import { DynamicStandingsAlgorithm } from "./DynamicStandingsAlgorithm";
import { EmailLogService } from "./EmailLogService";
import { GameEditorService } from "./GameEditorService";
import { GameService } from "./GameService";
import { LeagueConfigService } from "./LeagueConfigService";
import { LeagueService } from "./LeagueService";
import { OrganizationService } from "./OrganizationService";
import { PaymentService } from "./PaymentService";
import { PermissionsService } from "./PermissionsService";
import { RegistrationSystemService } from "./RegistrationSystemService";
import { SchedulingService } from "./SchedulingService";
import { SeasonService } from "./SeasonService";
import { SettingsService } from "./SettingsService";
import { SortingAlgorithmFactory } from "./SortingAlgorithmFactory";
import { SportsService } from "./SportsService";
import { StandingsService } from "./StandingsService";
import { TeamLevelService } from "./TeamLevelService";
import { TeamRegistrationService } from "./TeamRegistrationService";
import { TeamService } from "./TeamService";
import { TournamentsService } from "./TournamentsService";
import { UserService } from "./UserService";
import { CommonVanityUrlService } from "./VanityUrlService";
import { GraphqlClient } from "./GraphqlClient";

@NgModule({
  id: ServicesModuleName,
  declarations: [],
  providers: [
    AuthService,
    AgeGroupService,
    DynamicStandingsAlgorithm,
    GameEditorService,
    LeagueService,
    OrganizationService,
    PermissionsService,
    SchedulingService,
    GraphqlClient,
    GameService,
    SeasonService,
    SettingsService,
    SortingAlgorithmFactory,
    SportsService,
    StandingsService,
    TeamRegistrationService,
    TeamService,
    TournamentsService,
    UserService,
    AvailabilityService,
    EmailLogService,
    RegistrationSystemService,
    PaymentService,
    TeamLevelService,
    CommonVanityUrlService,
    LeagueConfigService,
  ],
})
export class ServicesModule {
  constructor() { }
}
